export default __webpack_public_path__ + "static/media/S-003.dfc4e347.png";